import { render, staticRenderFns } from "./PlayLogo.vue?vue&type=template&id=4c82cf96&scoped=true"
import script from "./PlayLogo.vue?vue&type=script&lang=js"
export * from "./PlayLogo.vue?vue&type=script&lang=js"
import style0 from "./PlayLogo.vue?vue&type=style&index=0&id=4c82cf96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c82cf96",
  null
  
)

export default component.exports